import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { ColumnEditorOptions } from "primereact/column";
import { mapDefectEstimatedCosts } from "../../utils/defectTableHelper";

export const EstimateCostEditorDropdown = (options: ColumnEditorOptions) =>  {
    const estimateCostOptions = mapDefectEstimatedCosts();

    const onChange = (event: DropdownChangeEvent) => {
        if (options.editorCallback) {
            options.editorCallback(event.target.value);
        }
    };

    return (
        <Dropdown value={options.value} onChange={onChange} options={estimateCostOptions} scrollHeight="400px" />
    )
}